import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

export const NOT_ENABLED_COPY = 'Not enabled for this workspace. Contact your Meridian account manager.';

const UpgradeModalContext = createContext({ open: () => {}, close: () => {} });

export function useUpgradeModal() {
  return useContext(UpgradeModalContext);
}

export function UpgradeModalProvider({ children }) {
  const [state, setState] = useState(null);
  const open = useCallback((opts) => setState(opts || {}), []);
  const close = useCallback(() => setState(null), []);
  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <UpgradeModalContext.Provider value={value}>
      {children}
      <Dialog open={!!state} onOpenChange={(next) => { if (!next) close(); }}>
        <DialogContent className="max-w-md" data-testid="not-enabled-modal">
          <DialogHeader className="space-y-2">
            <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center mb-2">
              <Lock className="w-5 h-5 text-muted-foreground" />
            </div>
            <DialogTitle data-testid="not-enabled-modal-title">{state?.label || 'This capability'}</DialogTitle>
            <DialogDescription data-testid="not-enabled-modal-body">{NOT_ENABLED_COPY}</DialogDescription>
          </DialogHeader>
          <div className="flex justify-end">
            <Button variant="outline" onClick={close} data-testid="not-enabled-modal-close">Close</Button>
          </div>
        </DialogContent>
      </Dialog>
    </UpgradeModalContext.Provider>
  );
}

export default UpgradeModalProvider;
